/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desktop_Banner_Dont_Show_AgainInputs */

const en_desktop_banner_dont_show_again = /** @type {(inputs: Desktop_Banner_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't show again`)
};

const fr_desktop_banner_dont_show_again = /** @type {(inputs: Desktop_Banner_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne plus afficher`)
};

const de_desktop_banner_dont_show_again = /** @type {(inputs: Desktop_Banner_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht wieder anzeigen`)
};

const it_desktop_banner_dont_show_again = /** @type {(inputs: Desktop_Banner_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non mostrare più`)
};

const ru_desktop_banner_dont_show_again = /** @type {(inputs: Desktop_Banner_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Больше не появляйтесь.`)
};

const es_desktop_banner_dont_show_again = /** @type {(inputs: Desktop_Banner_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No volver a mostrar`)
};

const zh_cn2_desktop_banner_dont_show_again = /** @type {(inputs: Desktop_Banner_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不要再次显示`)
};

const ja_desktop_banner_dont_show_again = /** @type {(inputs: Desktop_Banner_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再度表示しない`)
};

const hi_desktop_banner_dont_show_again = /** @type {(inputs: Desktop_Banner_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दोबारा मत दिखाओ`)
};

const pt_pt2_desktop_banner_dont_show_again = /** @type {(inputs: Desktop_Banner_Dont_Show_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não mostrar novamente`)
};

/**
* | output |
* | --- |
* | "Don't show again" |
*
* @param {Desktop_Banner_Dont_Show_AgainInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const desktop_banner_dont_show_again = /** @type {((inputs?: Desktop_Banner_Dont_Show_AgainInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Banner_Dont_Show_AgainInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_desktop_banner_dont_show_again(inputs)
	if (locale === "de") return de_desktop_banner_dont_show_again(inputs)
	if (locale === "it") return it_desktop_banner_dont_show_again(inputs)
	if (locale === "ru") return ru_desktop_banner_dont_show_again(inputs)
	if (locale === "es") return es_desktop_banner_dont_show_again(inputs)
	if (locale === "zh-CN") return zh_cn2_desktop_banner_dont_show_again(inputs)
	if (locale === "ja") return ja_desktop_banner_dont_show_again(inputs)
	if (locale === "hi") return hi_desktop_banner_dont_show_again(inputs)
	if (locale === "pt-PT") return pt_pt2_desktop_banner_dont_show_again(inputs)
	return en_desktop_banner_dont_show_again(inputs)
});